import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@tubo/ui/components/ui/tabs";
import { CleanProfilesTab } from "@client/components/data-center/cleaning/clean-profiles-tab";
import { CleanRunsTab } from "@client/components/data-center/cleaning/clean-runs-tab";

export const Route = createFileRoute("/_app/data-center/cleaning/")({
  component: DataCleaningPage,
  validateSearch: (search: Record<string, unknown>) => ({
    tab: search.tab === "runs" ? "runs" : "profiles",
    profileId: typeof search.profileId === "string" && search.profileId ? search.profileId : undefined,
  }),
});

function DataCleaningPage() {
  const { tab, profileId } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const setTab = (next: string) =>
    void navigate({ search: (prev) => ({ ...prev, tab: next === "runs" ? "runs" : "profiles" }), replace: true });

  return (
    <div className="flex flex-col gap-4 p-4">
      <div>
        <h1 className="text-lg font-semibold">数据清洗</h1>
        <p className="text-sm text-muted-foreground">
          把脏源表洗成规范化表格（步骤链算子 + 词表归一 + 人工确认标记），衍生文件可作为数据抽取任务的源文件入库。
        </p>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="profiles">清洗方案</TabsTrigger>
          <TabsTrigger value="runs">运行记录</TabsTrigger>
        </TabsList>
        <TabsContent value="profiles">
          <CleanProfilesTab />
        </TabsContent>
        <TabsContent value="runs">
          <CleanRunsTab profileId={profileId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
